export default __webpack_public_path__ + "static/media/haha.541432bf.png";